import { onMounted, ref} from 'vue'
import { useToast } from 'primevue/usetoast'
import { toTypedSchema } from '@vee-validate/zod'
import { useForm } from 'vee-validate'
import { mergeSchema } from '@/schemas/mergeSchema'
import { useRouter } from 'vue-router'
import { getYarnById } from '@/api/yarns'


export const useMergeForm = (formType: 'add' | 'edit' | 'view'): any => {
    const { values, handleSubmit, errors, setErrors, resetForm, meta, setFieldValue } = useForm({
        validationSchema: toTypedSchema(mergeSchema)
    })
    const toast = useToast()
    const loading = ref(false)
    const router = useRouter()


    const showToast = (type: 'success' | 'error', title: string, message: string) => {
        toast.add({
          severity: type,
          summary: title,
          detail: message,
          life: 5000
        })
      }

    onMounted(async () => {
      if(formType !== 'add') {
        const yarnId = router.currentRoute.value.params.id as string
        const yarn = await getYarnById(yarnId)

       if(yarn){
        resetForm({
          values: { ...yarn }
        })
       }
      }
    })

    return {
        values,
        handleSubmit,
        errors,
        setErrors,
        resetForm,
        meta,
        setFieldValue,
        showToast,
        formType,
        loading
    }
}